<template>
  <div class="app">
    <div class="container" id="container">
      <div v-if="sectionIndex==0">
        <div class="block1" id="block">
          <div class="content">
            <div class="head">
              <div class="text">坚守篇</div>
              <div class="text-en">INSISTING</div>
            </div>
            <div class="describe">
              <div class="text">“质量是上汽大众的生命”，35年一路走来，未曾改变的是对品质的坚守，恪守品质，初心不忘，是写进每一位上汽大众人心中的标尺。</div>
              <div
                class="text-en"
              >"Quality is the life of SAIC VOLKSWAGEN ".Over the 35 years of development, The company has always focused on high quality. Insists on the original aspiration is the priority of it's production.</div>
            </div>
            <div v-if="showCover==false" class="click clickStyle" @click="changeShowCoverTrue()">
              <img alt="xxx" src="../../assets/picshow/imgs/202.gif" style="width: 100%;" />
            </div>
          </div>
          <div v-if="showCover==false" class="back" @click="JumpTheme()">
            <div class="img">
              <img alt="xxx" src="../../assets/picshow/imgs/207.png" style="width: 100%;" />
            </div>
            <div class="text icon-text-black">返回</div>
          </div>
          <div v-if="showCover==false" class="jump-left" @click="changeIndex2()">
            <div class="img">
              <img alt="xxx" src="../../assets/picshow/imgs/203.png" style="width: 100%;" />
            </div>
            <div class="text icon-text-black">创新篇</div>
          </div>
          <div v-if="showCover==false" class="jump-right" @click="changeIndex1()">
            <div class="text icon-text-black">拼搏篇</div>
            <div class="img">
              <img alt="xxx" src="../../assets/picshow/imgs/204.png" style="width: 100%;" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="sectionIndex==1">
        <div class="block2" id="block">
          <div class="content">
            <div class="head">
              <div class="text">拼搏篇</div>
              <div class="text-en">STRIVING</div>
            </div>
            <div class="describe">
              <div
                class="text"
              >繁忙有序的生产线上，灵感迸发的实验台前，思想碰撞的会议室里，每一个平凡的岗位，因为不懈的拼搏而熠熠生辉，做更好的产品，提供更好的服务，是我们共同的目标！</div>
              <div
                class="text-en"
              >Over the past 35 years, SAIC VOLKSWAGEN keeps making breakthroughs and develops by following the trends. Every staff here works together and shares efforts. During this process, numerous magic moments and events are recorded by photos. The photo exhibition "We Are All The People Of SAIC VOLKSWAGEN" presents our stories, and records the details of struggle.</div>
            </div>
            <div
              v-if="showCover==false"
              class="click-pinbo clickStyle"
              @click="changeShowCoverTrue()"
            >
              <img alt="xxx" src="../../assets/picshow/imgs/202.gif" style="width: 100%;" />
            </div>
          </div>
          <div v-if="showCover==false" class="back" @click="JumpTheme()">
            <div class="img">
              <img alt="xxx" src="../../assets/picshow/imgs/207.png" style="width: 100%;" />
            </div>
            <div class="text icon-text-black">返回</div>
          </div>
          <div v-if="showCover==false" class="jump-left" @click="changeIndex0()">
            <div class="img">
              <img alt="xxx" src="../../assets/picshow/imgs/203.png" style="width: 100%;" />
            </div>
            <div class="text icon-text-black">坚守篇</div>
          </div>
          <div v-if="showCover==false" class="jump-right" @click="changeIndex2()">
            <div class="text icon-text-black">创新篇</div>
            <div class="img">
              <img alt="xxx" src="../../assets/picshow/imgs/204.png" style="width: 100%;" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="sectionIndex==2">
        <div class="block3" id="block">
          <div class="content">
            <div class="head">
              <div class="text">创新篇</div>
              <div class="text-en-chuangxin">INNOVATING</div>
            </div>
            <div class="describe">
              <div class="text">数字化的浪潮席卷而来，新能源的发展大势所趋，上汽大众始终勇立潮头，拥抱变革，共同创造美好的未来！</div>
              <div
                class="text-en"
              >As the coming of digitalization trend and the progress of new energy technology, SAIC VOLKSWAGEN keeps taking the lead to make innovations, so as to create a bright future.</div>
            </div>
            <div
              v-if="showCover==false"
              class="click-chuangxin clickStyle"
              @click="changeShowCoverTrue()"
            >
              <img alt="xxx" src="../../assets/picshow/imgs/202.gif" style="width: 100%;" />
            </div>
          </div>
          <div v-if="showCover==false" class="back" @click="JumpTheme()">
            <div class="img">
              <img alt="xxx" src="../../assets/picshow/imgs/207.png" style="width: 100%;" />
            </div>
            <div class="text icon-text-black">返回</div>
          </div>
          <div v-if="showCover==false" class="jump-left" @click="changeIndex1()">
            <div class="img">
              <img alt="xxx" src="../../assets/picshow/imgs/203.png" style="width: 100%;" />
            </div>
            <div class="text icon-text-black">拼搏篇</div>
          </div>
          <div v-if="showCover==false" class="jump-right" @click="changeIndex0()">
            <div class="text icon-text-black">坚守篇</div>
            <div class="img">
              <img alt="xxx" src="../../assets/picshow/imgs/204.png" style="width: 100%;" />
            </div>
          </div>
        </div>
      </div>
      <div class="cover" v-if="showCover"></div>
      <div class="popup popup-1" v-if="showpop1">
        <div class="left" id="popLeft"></div>
        <div class="cover-left" v-if="showpop1"></div>
        <div class="right" id="popRight"></div>
        <div class="cover-right" v-if="showpop1"></div>
        <div class="center" id="popCenter"></div>
      </div>
      <div class="popup popup-2" v-if="showpop2">
        <div class="left" id="popLeft"></div>
        <div class="cover-left" v-if="showpop2"></div>
        <div class="right" id="popRight"></div>
        <div class="cover-right" v-if="showpop2"></div>
        <div class="center" id="popCenter"></div>
      </div>
      <div class="popup popup-3" v-if="showpop3">
        <div class="left" id="popLeft"></div>
        <div class="cover-left" v-if="showpop3"></div>
        <div class="right" id="popRight"></div>
        <div class="cover-right" v-if="showpop3"></div>
        <div class="center" id="popCenter"></div>
      </div>
      <div class="popup2" v-if="showCover">
        <table>
          <tr>
            <td class="left clickStyle" @click="secToLeft()">
              <img alt="xxx" src="../../assets/picshow/imgs/502.png" />
            </td>
            <td class="content-table">
              <div class="text">{{popContent.text}}</div>
              <div class="text-en">{{popContent.textEn}}</div>
            </td>
            <td class="right clickStyle" @click="secToRight()">
              <img alt="xxx" src="../../assets/picshow/imgs/503.png" />
            </td>
          </tr>
        </table>
      </div>
      <div class="popup3" v-if="showCover">
        <div class="close clickStyle" @click="changeShowCoverFalse()">
          <img alt="xxx" src="../../assets/picshow/imgs/501.png" style="width: 100%;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrowserType, getBrowserHight } from "@/components/js/screen.js";
let img211 = require("../../static/picshow/imgs/211.jpg");
let img212 = require("../../static/picshow/imgs/212.jpg");
let img213 = require("../../static/picshow/imgs/213.jpg");
let img214 = require("../../static/picshow/imgs/214.jpg");
let img215 = require("../../static/picshow/imgs/215.jpg");
let img216 = require("../../static/picshow/imgs/216.jpg");
let img217 = require("../../static/picshow/imgs/217.jpg");
let img218 = require("../../static/picshow/imgs/218.jpg");
let img219 = require("../../static/picshow/imgs/219.jpg");
let img220 = require("../../static/picshow/imgs/220.jpg");
let img221 = require("../../static/picshow/imgs/221.jpg");
let img311 = require("../../static/picshow/imgs/311.jpg");
let img312 = require("../../static/picshow/imgs/312.jpg");
let img313 = require("../../static/picshow/imgs/313.jpg");
let img314 = require("../../static/picshow/imgs/314.jpg");
let img315 = require("../../static/picshow/imgs/315.jpg");
let img316 = require("../../static/picshow/imgs/316.jpg");
let img3162 = require("../../static/picshow/imgs/3162.jpg");
let img3163 = require("../../static/picshow/imgs/3163.jpg");
let img3164 = require("../../static/picshow/imgs/3164.jpg");
let img317 = require("../../static/picshow/imgs/317.jpg");
let img318 = require("../../static/picshow/imgs/318.jpg");
let img3182 = require("../../static/picshow/imgs/3182.jpg");
let img3183 = require("../../static/picshow/imgs/3183.jpg");
let img411 = require("../../static/picshow/imgs/411.jpg");
let img4112 = require("../../static/picshow/imgs/4112.jpg");
let img4113 = require("../../static/picshow/imgs/4113.jpg");
let img412 = require("../../static/picshow/imgs/412.jpg");
let img4122 = require("../../static/picshow/imgs/4122.jpg");
let img4123 = require("../../static/picshow/imgs/4123.jpg");
let img413 = require("../../static/picshow/imgs/413.jpg");
let img4132 = require("../../static/picshow/imgs/4132.jpg");
let img414 = require("../../static/picshow/imgs/414.jpg");
let img4142 = require("../../static/picshow/imgs/4142.jpg");
let img4143 = require("../../static/picshow/imgs/4143.jpg");
let img4152 = require("../../static/picshow/imgs/4152.jpg");
let img417 = require("../../static/picshow/imgs/417.jpg");
let img4182 = require("../../static/picshow/imgs/4182.jpg");
let img419 = require("../../static/picshow/imgs/419.jpg");
let img4192 = require("../../static/picshow/imgs/4192.jpg");
export default {
  name: "Picshow",
  props: ["jumpBack"],
  data() {
    return {
      sectionIndex: 0, // 翻页的页签
      showCover: false, // 是否出现弹出框
      showpop1: false,
      showpop2: false,
      showpop3: false,
      sec1Index: 0, // 第一个的内容
      sec2Index: 0, // 第二个的内容
      sec3Index: 0, // 第三个的内容
      popContent: { pic1: "", pic2: "", pic3: "", text: "", textEn: "" }
    };
  },
  mounted: function() {
    this.setSectionHeight();
    // 浏览器改变大小监听事件
    window.onresize = this.setSectionHeight;
  },
  methods: {
    setSectionHeight() {
      const h = getBrowserHight();
      const height = `${h}px`;
      document.getElementById("block").style.height = height;
    },
    JumpTheme() {
      //this.$router.push({ path: "/pictheme" });
      //this.$emit("jumpBack");
      location.reload();
    },
    changeIndex0() {
      this.sectionIndex = 0;
    },
    changeIndex1() {
      this.sectionIndex = 1;
    },
    changeIndex2() {
      this.sectionIndex = 2;
    },
    changeShowCoverTrue() {
      this.showCover = true;
      if (this.sectionIndex == 0) {
        this.showpop1 = true;
      } else if (this.sectionIndex == 1) {
        this.showpop2 = true;
      } else if (this.sectionIndex == 2) {
        this.showpop3 = true;
      }
      document.getElementsByTagName("html")[0].style.height = "100%";
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
      this.showPopContent();
    },
    changeShowCoverFalse() {
      document.getElementsByTagName("html")[0].style.height = "";
      document.getElementsByTagName("html")[0].style.overflow = "";
      this.showCover = false;
      this.showpop1 = false;
      this.showpop2 = false;
      this.showpop3 = false;
      sec1Index = 0;
      sec2Index = 0;
      sec3Index = 0;
    },
    secToLeft() {
      if (this.sectionIndex == 0) {
        if (this.sec1Index > 0) {
          this.sec1Index--;
        } else if (this.sec1Index <= 0) {
          this.sec1Index = 10;
        }
      } else if (this.sectionIndex == 1) {
        if (this.sec2Index > 0) {
          this.sec2Index--;
        } else if (this.sec2Index <= 0) {
          this.sec2Index = 12;
        }
      } else if (this.sectionIndex == 2) {
        if (this.sec3Index > 0) {
          this.sec3Index--;
        } else if (this.sec3Index <= 0) {
          this.sec3Index = 15;
        }
      }
      this.showPopContent();
    },
    secToRight() {
      if (this.sectionIndex == 0) {
        if (this.sec1Index < 10) {
          this.sec1Index++;
        } else if (this.sec1Index >= 10) {
          this.sec1Index = 0;
        }
      } else if (this.sectionIndex == 1) {
        if (this.sec2Index < 12) {
          this.sec2Index++;
        } else if (this.sec2Index >= 12) {
          this.sec2Index = 0;
        }
      } else if (this.sectionIndex == 2) {
        if (this.sec3Index < 15) {
          this.sec3Index++;
        } else if (this.sec3Index >= 15) {
          this.sec3Index = 0;
        }
      }
      this.showPopContent();
    },
    showPopContent() {
      this.popContent = {};
      if (this.sectionIndex == 0) {
        if (this.sec1Index == 0) {
          this.popContent = {
            pic1: img220,
            pic2: img211,
            pic3: img212,
            title: "坚守篇 Insisting",
            text: "1983年，第一辆桑塔纳组装成功。",
            textEn: "In 1983, The first Santana was successfully assembled."
          };
        } else if (this.sec1Index == 1) {
          this.popContent = {
            pic1: img211,
            pic2: img212,
            pic3: img213,
            title: "坚守篇 Insisting",
            text: "2012年，参与缔造第一辆桑塔纳的员工与全新一代桑塔纳合影。",
            textEn:
              "In 2012, employees participated in assembling of the first Santana took a group photo with a new generation of Santana."
          };
        } else if (this.sec1Index == 2) {
          this.popContent = {
            pic1: img212,
            pic2: img213,
            pic3: img214,
            title: "坚守篇 Insisting",
            text: "每一个零件的精准匹配，只为每一辆车的完美。",
            textEn:
              "Accurate matching of every part, just for the perfection of every car."
          };
        } else if (this.sec1Index == 3) {
          this.popContent = {
            pic1: img213,
            pic2: img214,
            pic3: img215,
            title: "坚守篇 Insisting",
            text: "30多年如一日，质保人用坚守诠释着“质量”的承诺。",
            textEn:
              "For decades,people of quality assurance adhere to their commitment of 'quality'."
          };
        } else if (this.sec1Index == 4) {
          this.popContent = {
            pic1: img214,
            pic2: img215,
            pic3: img216,
            title: "坚守篇 Insisting",
            text:
              "35年来，我们一直倾听中国用户需求，坚持做最懂中国消费者的设计。",
            textEn:
              "Over the past 35 years, we have been listening to the needs of Chinese users and insisting on the design that understands Chinese consumers best."
          };
        } else if (this.sec1Index == 5) {
          this.popContent = {
            pic1: img215,
            pic2: img216,
            pic3: img217,
            title: "",
            text: "坚持用心聆听来自质量的每一个声音。",
            textEn: "Keep listening to every voice from quality."
          };
        } else if (this.sec1Index == 6) {
          this.popContent = {
            pic1: img216,
            pic2: img217,
            pic3: img218,
            title: "坚守篇 Insisting",
            text: "坚持绿色生产，守护我们的家园。",
            textEn: "Green production for our environment."
          };
        } else if (this.sec1Index == 7) {
          this.popContent = {
            pic1: img217,
            pic2: img218,
            pic3: img219,
            title: "坚守篇 Insisting",
            text: "一丝不苟，用心打磨品质。",
            textEn: "Meticulously craftsmanship."
          };
        } else if (this.sec1Index == 8) {
          this.popContent = {
            pic1: img218,
            pic2: img219,
            pic3: img220,
            title: "坚守篇 Insisting",
            text: "细微之间，坚持一颗工匠之心。",
            textEn: "Craftsmanship in every detail."
          };
        } else if (this.sec1Index == 9) {
          this.popContent = {
            pic1: img219,
            pic2: img220,
            pic3: img221,
            title: "坚守篇 Insisting",
            text:
              "真诚的笑容、贴心的关爱，坚持以热情和专业的服务赢得千万客户的口碑。",
            textEn:
              "Sincere smile, caring, enthusiasm and professional service to win good customer reputation."
          };
        } else if (this.sec1Index == 10) {
          this.popContent = {
            pic1: img220,
            pic2: img221,
            pic3: img211,
            title: "坚守篇 Insisting",
            text: "下班路上，意犹未尽，伴着落日余晖继续闪耀创想的光芒！",
            textEn:
              "On our way home, creative thoughts continue to sparkle in the sunset!"
          };
        }
      } else if (this.sectionIndex == 1) {
        if (this.sec2Index == 0) {
          this.popContent = {
            pic1: img3183,
            pic2: img311,
            pic3: img312,
            title: "拼搏篇 Striving",
            text: "无论身处哪个工位，我们都拥有同样的拼搏情怀。",
            textEn:
              "No matter where we are, we have the same spirit of striving."
          };
        } else if (this.sec2Index == 1) {
          this.popContent = {
            pic1: img311,
            pic2: img312,
            pic3: img313,
            title: "拼搏篇 Striving",
            text: "不一样的岗位，一样的拼搏努力。",
            textEn: `Joints efforts in different posts.`
          };
        } else if (this.sec2Index == 2) {
          this.popContent = {
            pic1: img312,
            pic2: img313,
            pic3: img314,
            title: "拼搏篇 Striving",
            text: "繁忙而有序的生产线，是每一位一线员工拼搏的战场。",
            textEn:
              "The busy and orderly production line is the battleground for every front-line employee."
          };
        } else if (this.sec2Index == 3) {
          this.popContent = {
            pic1: img313,
            pic2: img314,
            pic3: img315,
            title: "拼搏篇 Striving",
            text: "平凡的岗位，因为你的拼搏而绽放光芒。",
            textEn: `Ordinary positions shine because of your hard work.`
          };
        } else if (this.sec2Index == 4) {
          this.popContent = {
            pic1: img314,
            pic2: img315,
            pic3: img316,
            title: "拼搏篇 Striving",
            text: "恪守职责使命 书写拼搏华章。",
            textEn: "Adhere to responsibilities and struggle for achievements."
          };
        } else if (this.sec2Index == 5) {
          this.popContent = {
            pic1: img315,
            pic2: img316,
            pic3: img3162,
            title: "拼搏篇 Striving",
            text:
              "西进新疆，北上黑河，不怕苦的试车员们拼搏在“全天候”“全路况”的测试道路上。",
            textEn: `Going west into Xinjiang, heading north to the Black River, test drivers faced all difficulties and struggled on the "all-weather" and "all-condition" test roads.`
          };
        } else if (this.sec2Index == 6) {
          this.popContent = {
            pic1: img316,
            pic2: img3162,
            pic3: img3163,
            title: "拼搏篇 Striving",
            text:
              "西进新疆，北上黑河，不怕苦的试车员们拼搏在“全天候”“全路况”的测试道路上。",
            textEn: `Going west into Xinjiang, heading north to the Black River, test drivers faced all difficulties and struggled on the "all-weather" and "all-condition" test roads.`
          };
        } else if (this.sec2Index == 7) {
          this.popContent = {
            pic1: img3162,
            pic2: img3163,
            pic3: img3164,
            title: "拼搏篇 Striving",
            text:
              "西进新疆，北上黑河，不怕苦的试车员们拼搏在“全天候”“全路况”的测试道路上。",
            textEn: `Going west into Xinjiang, heading north to the Black River, test drivers faced all difficulties and struggled on the "all-weather" and "all-condition" test roads.`
          };
        } else if (this.sec2Index == 8) {
          this.popContent = {
            pic1: img3163,
            pic2: img3164,
            pic3: img317,
            title: "拼搏篇 Striving",
            text:
              "西进新疆，北上黑河，不怕苦的试车员们拼搏在“全天候”“全路况”的测试道路上。",
            textEn: `Going west into Xinjiang, heading north to the Black River, test drivers faced all difficulties and struggled on the "all-weather" and "all-condition" test roads.`
          };
        } else if (this.sec2Index == 9) {
          this.popContent = {
            pic1: img3164,
            pic2: img317,
            pic3: img318,
            title: "拼搏篇 Striving",
            text:
              "他们站在疫情防控的最前沿，和时间赛跑，和自己赛跑，为每一位员工的安全保驾护航。",
            textEn: `They standed at the forefront of epidemic prevention and control, raced against time and themselves, ensuring safety of every employee.`
          };
        } else if (this.sec2Index == 10) {
          this.popContent = {
            pic1: img317,
            pic2: img318,
            pic3: img3182,
            title: "拼搏篇 Striving",
            text: "奋战在疫情防控的最前沿的他们，为每一位员工的安全保驾护航。",
            textEn:
              "They standed at the forefront of epidemic prevention and control, ensuring safety of every employee."
          };
        } else if (this.sec2Index == 11) {
          this.popContent = {
            pic1: img318,
            pic2: img3182,
            pic3: img3183,
            title: "拼搏篇 Striving",
            text: "奋战在疫情防控的最前沿的他们，为每一位员工的安全保驾护航。",
            textEn:
              "They standed at the forefront of epidemic prevention and control, ensuring safety of every employee."
          };
        } else if (this.sec2Index == 12) {
          this.popContent = {
            pic1: img3182,
            pic2: img3183,
            pic3: img311,
            title: "拼搏篇 Striving",
            text: "奋战在疫情防控的最前沿的他们，为每一位员工的安全保驾护航。",
            textEn:
              "They standed at the forefront of epidemic prevention and control, ensuring safety of every employee."
          };
        }
      } else if (this.sectionIndex == 2) {
        if (this.sec3Index == 0) {
          this.popContent = {
            pic1: img4192,
            pic2: img411,
            pic3: img412,
            title: "创新篇 Innovating",
            text:
              "IT人为企业数字化转型打通全方位、全过程、全领域的数据实时交互。",
            textEn:
              "IT workers provide all-round, whole process and all field real-time data interaction for digital transformation."
          };
        } else if (this.sec3Index == 1) {
          this.popContent = {
            pic1: img411,
            pic2: img4112,
            pic3: img4113,
            title: "创新篇 Innovating",
            text:
              "IT人为企业数字化转型打通全方位、全过程、全领域的数据实时交互。",
            textEn:
              "IT workers provide all-round, whole process and all field real-time data interaction for digital transformation."
          };
        } else if (this.sec3Index == 2) {
          this.popContent = {
            pic1: img4112,
            pic2: img4113,
            pic3: img412,
            title: "创新篇 Innovating",
            text:
              "IT人为企业数字化转型打通全方位、全过程、全领域的数据实时交互。",
            textEn:
              "IT workers provide all-round, whole process and all field real-time data interaction for digital transformation."
          };
        } else if (this.sec3Index == 3) {
          this.popContent = {
            pic1: img4113,
            pic2: img412,
            pic3: img4122,
            title: "创新篇 Innovating",
            text: "智能化，是物流管理的变革，更是精益化管理理念的创新应用。",
            textEn:
              "Intelligent network is the transform of logistics management and also the innovative application of lean management concept."
          };
        } else if (this.sec3Index == 4) {
          this.popContent = {
            pic1: img412,
            pic2: img4122,
            pic3: img4123,
            title: "创新篇 Innovating",
            text: "智能化，是物流管理的变革，更是精益化管理理念的创新应用。",
            textEn:
              "Intelligent network is the transform of logistics management and also the innovative application of lean management concept."
          };
        } else if (this.sec3Index == 5) {
          this.popContent = {
            pic1: img4122,
            pic2: img4123,
            pic3: img413,
            title: "创新篇 Innovating",
            text: "智能化，是物流管理的变革，更是精益化管理理念的创新应用。",
            textEn:
              "Intelligent network is the transform of logistics management and also the innovative application of lean management concept."
          };
        } else if (this.sec3Index == 6) {
          this.popContent = {
            pic1: img4123,
            pic2: img413,
            pic3: img4132,
            title: "创新篇 Innovating",
            text: "造型研发",
            textEn: "Design R & D"
          };
        } else if (this.sec3Index == 7) {
          this.popContent = {
            pic1: img413,
            pic2: img4132,
            pic3: img414,
            title: "创新篇 Innovating",
            text: "造型研发",
            textEn: "Design R & D"
          };
        } else if (this.sec3Index == 8) {
          this.popContent = {
            pic1: img4132,
            pic2: img414,
            pic3: img4142,
            title: "创新篇 Innovating",
            text: "虚拟现实研发",
            textEn: "Virtual Reality R & D"
          };
        } else if (this.sec3Index == 9) {
          this.popContent = {
            pic1: img414,
            pic2: img4142,
            pic3: img4143,
            title: "创新篇 Innovating",
            text: "虚拟现实研发",
            textEn: "Virtual Reality R & D"
          };
        } else if (this.sec3Index == 10) {
          this.popContent = {
            pic1: img4142,
            pic2: img4143,
            pic3: img4152,
            title: "创新篇 Innovating",
            text: "虚拟现实研发",
            textEn: "Virtual Reality R & D"
          };
        } else if (this.sec3Index == 11) {
          this.popContent = {
            pic1: img4143,
            pic2: img4152,
            pic3: img417,
            title: "创新篇 Innovating",
            text: "智能驾驶研发",
            textEn: "Autonomous Driving R & D"
          };
        } else if (this.sec3Index == 12) {
          this.popContent = {
            pic1: img4152,
            pic2: img417,
            pic3: img4182,
            title: "创新篇 Innovating",
            text: "电磁兼容试验",
            textEn: "Electromagnetic Compatibility Test"
          };
        } else if (this.sec3Index == 13) {
          this.popContent = {
            pic1: img417,
            pic2: img4182,
            pic3: img419,
            title: "创新篇 Innovating",
            text: "新能源车研发",
            textEn: "New Energy Vehicle Engineering R&D"
          };
        } else if (this.sec3Index == 14) {
          this.popContent = {
            pic1: img4182,
            pic2: img419,
            pic3: img4192,
            title: "创新篇 Innovating",
            text: "移动互联团队",
            textEn: "Connectivity Team"
          };
        } else if (this.sec3Index == 15) {
          this.popContent = {
            pic1: img419,
            pic2: img4192,
            pic3: img411,
            title: "创新篇 Innovating",
            text: "移动互联团队",
            textEn: "Connectivity Team"
          };
        }
      }
      this.changeContentPic();
    },
    changeContentPic() {
      document.getElementById(
        "popLeft"
      ).style.backgroundImage = `url(${this.popContent.pic1})`;
      document.getElementById(
        "popCenter"
      ).style.backgroundImage = `url(${this.popContent.pic2})`;
      document.getElementById(
        "popRight"
      ).style.backgroundImage = `url(${this.popContent.pic3})`;
    }
  }
};
</script>

<style scoped>
@font-face {
  font-family: myCu;
  src: url("../../assets/font/FZYouHJW_Cu.TTF"),
    url("../../assets/font/FZYouHJW_Cu.eot");
  /* IE9+,可以是具体的实际链接 */
}
@font-face {
  font-family: myCuEn;
  src: url("../../assets/font/Proxima-Nova-Bold.otf"),
    url("../../assets/font/Proxima-Nova-Bold.eot");
  /* IE9+,可以是具体的实际链接 */
}

@media screen and (min-width: 1px) {
  .app {
    position: relative;
  }
  .clickStyle {
    cursor: pointer;
  }
  .container {
    width: 100%;
    position: relative;
  }
  .container .block1 {
    background-image: url("../../assets/picshow/imgs/201.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .container .block2 {
    background-image: url("../../assets/picshow/imgs/301.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .container .block3 {
    background-image: url("../../assets/picshow/imgs/401.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .container .content {
    position: absolute;
    width: 40%;
    top: 25%;
    left: 30%;
  }

  .head {
    text-align: center;
    color: rgba(22, 133, 218, 1);
  }
  .head .text {
    font-size: 75px;
    font-family: myCu !important;
  }
  .head .text-en {
    font-size: 46px;
    font-family: myCuEn !important;
  }
  .head .text-en-chuangxin {
    font-size: 35px;
    font-family: myCuEn !important;
  }
  .describe {
    text-align: left;
    margin-top: 54px;
    padding: 0 60px;
    color: rgba(32, 32, 32, 1);
  }
  .describe .text {
    font-size: 18px;
    line-height: 28px;
  }
  .describe .text-en {
    font-size: 14px;
    line-height: 24px;
    margin-top: 24px;
  }
  .click {
    position: absolute;
    width: 222px;
    left: 50%;
    margin-left: -111px;
    margin-top: 120px;
  }
  .click-pinbo {
    position: absolute;
    width: 222px;
    left: 50%;
    margin-left: -111px;
    margin-top: 68px;
  }
  .click-chuangxin {
    position: absolute;
    width: 222px;
    left: 50%;
    margin-left: -111px;
    margin-top: 157px;
  }
  .back {
    position: absolute;
    top: 20px;
    right: 80px;
    cursor: pointer;
  }
  .back .img {
    position: relative;
    float: left;
    width: 24px;
    height: 24px;
    top: 6px;
  }
  .back .text {
    position: relative;
    float: left;
    margin-left: 10px;
  }
  .jump-left {
    position: absolute;
    bottom: 80px;
    left: 80px;
    cursor: pointer;
  }
  .jump-left .img {
    position: relative;

    width: 24px;
    height: 26px;
    display: inline-block;
    vertical-align: middle;
  }
  .jump-left .text {
    position: relative;

    margin-left: 10px;
  }
  .jump-right {
    position: absolute;
    bottom: 80px;
    right: 80px;
    cursor: pointer;
  }
  .jump-right .img {
    position: relative;

    width: 24px;
    height: 26px;
    display: inline-block;
    vertical-align: middle;
  }
  .jump-right .text {
    position: relative;

    margin-right: 10px;
  }
  .icon-text-black {
    font-size: 24px;
    display: inline-block;
    vertical-align: middle;
    color: rgba(32, 32, 32, 1);
  }
  .icon-text-blue {
    font-size: 24px;
    color: rgba(0, 119, 200, 1);
  }

  .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);

    /*指定一个元素的堆叠顺序,数值越大,表示在越上边*/
  }
  .popup {
    position: fixed;
    /*首先将位置固定住*/
    top: 8%;
    bottom: 28%;
    left: 0;
    right: 0;
  }
  .popup .left {
    position: absolute;
    width: 40%;
    left: 0%;
    top: 9%;
    height: 80%;

    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 10;
  }
  .popup .cover-left {
    position: absolute;
    width: 40%;
    left: 0%;
    top: 9%;
    height: 80%;
    background: rgba(2, 2, 2, 0.5);

    z-index: 80;
  }
  .popup .cover-right {
    position: absolute;
    width: 40%;
    right: 0%;
    top: 9%;
    height: 80%;
    background: rgba(2, 2, 2, 0.5);

    z-index: 80;
  }
  .popup .center {
    position: absolute;
    width: 50%;
    left: 25%;
    top: 0%;
    height: 100%;

    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 100;
  }
  .popup .right {
    position: absolute;
    width: 40%;
    right: 0%;
    top: 9%;
    height: 80%;

    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 10;
  }
  .popup-1 .left {
    background-image: url("../../static/picshow/imgs/221.jpg");
  }
  .popup-1 .center {
    background-image: url("../../static/picshow/imgs/211.jpg");
  }
  .popup-1 .right {
    background-image: url("../../static/picshow/imgs/212.jpg");
  }
  .popup-2 .left {
    background-image: url("../../static/picshow/imgs/3183.jpg");
  }
  .popup-2 .center {
    background-image: url("../../static/picshow/imgs/311.jpg");
  }
  .popup-2 .right {
    background-image: url("../../static/picshow/imgs/312.jpg");
  }
  .popup-3 .left {
    background-image: url("../../static/picshow/imgs/4192.jpg");
  }
  .popup-3 .center {
    background-image: url("../../static/picshow/imgs/411.jpg");
  }
  .popup-3 .right {
    background-image: url("../../static/picshow/imgs/4112.jpg");
  }
  .popup2 {
    position: fixed;
    /*首先将位置固定住*/
    height: 23%;
    bottom: 2%;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .popup2 {
    width: 100%;
  }
  .popup2 table {
    position: relative;
    width: 100%;
  }
  .popup2 td {
    text-align: center;
  }
  .popup2 .content-table {
    text-align: center;
    padding: 0 15px;
    width: 60%;
  }
  .popup2 .left {
    text-align: center;
    padding-right: 44px;
    width: 20%;
  }
  .popup2 .left img {
    width: 25px;
    height: 40px;
  }
  .popup2 .right {
    text-align: center;
    padding-left: 44px;
    width: 20%;
  }
  .popup2 .right img {
    width: 25px;
    height: 40px;
  }
  .popup2 .title {
    color: rgba(255, 255, 255, 1);
    font-size: 40px;
    line-height: 50px;
    font-weight: bold;
  }
  .popup2 .text {
    color: rgba(255, 255, 255, 1);
    font-size: 28px;
    line-height: 40px;
    margin-top: 10px;
  }
  .popup2 .text-en {
    color: rgba(255, 255, 255, 1);
    font-size: 25px;
    line-height: 40px;
    margin-top: 7px;
  }
  .popup3 {
    position: fixed;
    /*首先将位置固定住*/
    width: 28px;
    height: 28px;
    top: 2%;
    right: 2%;
    z-index: 200;
  }
}
@media screen and (min-width: 1px) and (max-width: 1300px) {
  .clickStyle {
    cursor: pointer;
  }
  .container {
    width: 100%;
  }
  .container .block1 {
    background-image: url("../../assets/picshow/imgs/201.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .container .block2 {
    background-image: url("../../assets/picshow/imgs/301.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .container .block3 {
    background-image: url("../../assets/picshow/imgs/401.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .container .content {
    position: absolute;
    width: 40%;
    top: 25%;
    left: 30%;
  }

  .head {
    text-align: center;
    color: rgba(22, 133, 218, 1);
  }
  .head .text {
    font-size: 50px;
    font-family: myCu !important;
  }
  .head .text-en {
    font-size: 31px;
    font-family: myCuEn !important;
  }
  .head .text-en-chuangxin {
    font-size: 24px;
    font-family: myCuEn !important;
  }
  .describe {
    text-align: left;
    margin-top: 20px;
    padding: 0 40px;
    color: rgba(32, 32, 32, 1);
  }
  .describe .text {
    font-size: 12px;
    line-height: 19px;
  }
  .describe .text-en {
    font-size: 12px;
    line-height: 16px;
    margin-top: 20px;
  }
  .click {
    position: absolute;
    width: 120px;
    left: 50%;
    margin-left: -60px;
    margin-top: 84px;
  }
  .click-pinbo {
    position: absolute;
    width: 120px;
    left: 50%;
    margin-left: -60px;
    margin-top: 18px;
  }
  .click-chuangxin {
    position: absolute;
    width: 120px;
    left: 50%;
    margin-left: -60px;
    margin-top: 92px;
  }
  .back {
    position: absolute;
    top: 20px;
    right: 80px;
    cursor: pointer;
  }
  .back .img {
    position: relative;
    float: left;
    width: 18px;
    height: 14px;
    top: 2px;
  }
  .back .text {
    position: relative;
    float: left;
    margin-left: 10px;
  }
  .jump-left {
    position: absolute;
    bottom: 80px;
    left: 80px;
    cursor: pointer;
  }
  .jump-left .img {
    position: relative;

    width: 18px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }
  .jump-left .text {
    position: relative;

    margin-left: 10px;
  }
  .jump-right {
    position: absolute;
    bottom: 80px;
    right: 80px;
    cursor: pointer;
  }
  .jump-right .img {
    position: relative;

    width: 18px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }
  .jump-right .text {
    position: relative;

    margin-right: 10px;
  }
  .icon-text-black {
    font-size: 16px;
    display: inline-block;
    vertical-align: middle;
    color: rgba(32, 32, 32, 1);
  }
  .icon-text-blue {
    font-size: 16px;
    line-height: 25px;
    color: rgba(0, 119, 200, 1);
  }

  .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);

    /*指定一个元素的堆叠顺序,数值越大,表示在越上边*/
  }
  .popup {
    position: fixed;
    /*首先将位置固定住*/
    top: 7%;
    bottom: 25%;
    left: 0;
    right: 0;
  }
  .popup .left {
    position: absolute;
    width: 40%;
    left: 0%;
    top: 9%;
    height: 80%;
    z-index: 10;
  }
  .popup .center {
    position: absolute;
    width: 50%;
    left: 25%;
    top: 0%;
    height: 100%;
    z-index: 100;
  }
  .popup .right {
    position: absolute;
    width: 40%;
    right: 0%;
    top: 9%;
    height: 80%;
    z-index: 10;
  }
  .popup2 {
    position: fixed;
    /*首先将位置固定住*/
    height: 20%;
    bottom: 5%;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .popup2 {
    width: 100%;
  }
  .popup2 table {
    position: relative;
    width: 100%;
  }
  .popup2 td {
    text-align: center;
  }
  .popup2 .content-table {
    text-align: center;
    padding: 0 15px;
    width: 60%;
  }
  .popup2 .left {
    text-align: center;
    padding-right: 44px;
    width: 20%;
  }
  .popup2 .left img {
    width: 15px;
    height: 25px;
  }
  .popup2 .right {
    text-align: center;
    padding-left: 44px;
    width: 20%;
  }
  .popup2 .right img {
    width: 15px;
    height: 25px;
  }
  .popup2 .title {
    color: rgba(255, 255, 255, 1);
    font-size: 27px;
    line-height: 33px;
    font-weight: bold;
  }
  .popup2 .text {
    color: rgba(255, 255, 255, 1);
    font-size: 18px;
    line-height: 27px;
    margin-top: 11px;
  }
  .popup2 .text-en {
    color: rgba(255, 255, 255, 1);
    font-size: 15px;
    line-height: 20px;
    margin-top: 8px;
  }
  .popup3 {
    position: fixed;
    /*首先将位置固定住*/
    width: 18px;
    height: 18px;
    top: 2%;
    right: 2%;
    z-index: 200;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .clickStyle {
    cursor: pointer;
  }
  .container {
    width: 100%;
  }
  .container .block1 {
    background-image: url("../../assets/picshow/imgs/201.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .container .block2 {
    background-image: url("../../assets/picshow/imgs/301.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .container .block3 {
    background-image: url("../../assets/picshow/imgs/401.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .container .content {
    position: absolute;
    width: 40%;
    top: 25%;
    left: 30%;
  }

  .head {
    text-align: center;
    color: rgba(22, 133, 218, 1);
  }
  .head .text {
    font-size: 62px;
    font-family: myCu !important;
  }
  .head .text-en {
    font-size: 38px;
    font-family: myCuEn !important;
  }
  .head .text-en-chuangxin {
    font-size: 24px;
    font-family: myCuEn !important;
  }
  .describe {
    text-align: left;
    margin-top: 54px;
    padding: 0 50px;
    color: rgba(32, 32, 32, 1);
  }
  .describe .text {
    font-size: 15px;
    line-height: 23px;
  }
  .describe .text-en {
    font-size: 12px;
    line-height: 16px;
    margin-top: 20px;
  }
  .click {
    position: absolute;
    width: 184px;
    left: 50%;
    margin-left: -92px;
    margin-top: 95px;
  }
  .click-pinbo {
    position: absolute;
    width: 184px;
    left: 50%;
    margin-left: -92px;
    margin-top: 50px;
  }
  .click-chuangxin {
    position: absolute;
    width: 184px;
    left: 50%;
    margin-left: -92px;
    margin-top: 130px;
  }
  .back {
    position: absolute;
    top: 20px;
    right: 80px;
    cursor: pointer;
  }
  .back .img {
    position: relative;
    float: left;
    width: 22px;
    height: 17px;
    top: 4px;
  }
  .back .text {
    position: relative;
    float: left;
    margin-left: 10px;
  }
  .jump-left {
    position: absolute;
    bottom: 80px;
    left: 80px;
    cursor: pointer;
  }
  .jump-left .img {
    position: relative;

    width: 17px;
    height: 19px;
    display: inline-block;
    vertical-align: middle;
  }
  .jump-left .text {
    position: relative;

    margin-left: 10px;
  }
  .jump-right {
    position: absolute;
    bottom: 80px;
    right: 80px;
    cursor: pointer;
  }
  .jump-right .img {
    position: relative;

    width: 17px;
    height: 19px;
    display: inline-block;
    vertical-align: middle;
  }
  .jump-right .text {
    position: relative;

    margin-right: 10px;
  }
  .icon-text-black {
    font-size: 20px;
    display: inline-block;
    vertical-align: middle;
    color: rgba(32, 32, 32, 1);
  }
  .icon-text-blue {
    font-size: 20px;
    color: rgba(0, 119, 200, 1);
  }

  .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);

    /*指定一个元素的堆叠顺序,数值越大,表示在越上边*/
  }
  .popup {
    position: fixed;
    /*首先将位置固定住*/
    top: 8%;
    bottom: 30%;
    left: 0;
    right: 0;
  }
  .popup .left {
    position: absolute;
    width: 40%;
    left: 0%;
    top: 9%;
    height: 80%;
    z-index: 10;
  }
  .popup .center {
    position: absolute;
    width: 50%;
    left: 25%;
    top: 0%;
    height: 100%;
    z-index: 100;
  }
  .popup .right {
    position: absolute;
    width: 40%;
    right: 0%;
    top: 9%;
    height: 80%;
    z-index: 10;
  }
  .popup2 {
    position: fixed;
    /*首先将位置固定住*/
    height: 23%;
    bottom: 2%;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .popup2 {
    width: 100%;
  }
  .popup2 table {
    position: relative;
    width: 100%;
  }
  .popup2 td {
    text-align: center;
  }
  .popup2 .content-table {
    text-align: center;
    padding: 0 15px;
    width: 60%;
  }
  .popup2 .left {
    text-align: center;
    padding-right: 44px;
    width: 20%;
  }
  .popup2 .left img {
    width: 29px;
    height: 49px;
  }
  .popup2 .right {
    text-align: center;
    padding-left: 44px;
    width: 20%;
  }
  .popup2 .right img {
    width: 29px;
    height: 49px;
  }
  .popup2 .title {
    color: rgba(255, 255, 255, 1);
    font-size: 33px;
    line-height: 41px;
    font-weight: bold;
  }
  .popup2 .text {
    color: rgba(255, 255, 255, 1);
    font-size: 25px;
    line-height: 33px;
    margin-top: 14px;
  }
  .popup2 .text-en {
    color: rgba(255, 255, 255, 1);
    font-size: 25px;
    line-height: 33px;
    margin-top: 5px;
  }
  .popup3 {
    position: fixed;
    /*首先将位置固定住*/
    width: 22px;
    height: 23px;
    top: 2%;
    right: 2%;
    z-index: 200;
  }
}
</style>